export default __webpack_public_path__ + "static/code-dots-7e2354af8b91e66342d610fda3e8893e.svg";